<template lang="html">
    <section class="section-skills" id="skills">
        <div class="row">
            <h2>Skills you will get</h2>
        </div>
        <div class="row skill-sets">
            <div class="col span-1-of-2 steps-box">
                <div class="works-step clearfix">
                    <transition
                        name="bounce"
                        enter-active-class="bounceInLeft"
                        leave-active-class="bounceOutRight">
                        <div>1</div>
                    </transition>
                    <b>增强国际视野</b>
                    <p>International Horizon Developing</p>
                </div>
                <div class="works-step clearfix">
                    <div>2</div>
                    <b>扩大人脉网络</b>
                    <p>Network Expanding</p>
                </div>
                <div class="works-step clearfix">
                    <div>3</div>
                    <b>收获个人经验，提升职场竞争力</b>
                    <p>Personal Experience & <br> Competitiveness</p>
                </div>
            </div>

            <div class="col span-1-of-2 steps-box">
                <div class="works-step clearfix">
                    <div>4</div>
                    <b>提高综合素养，为申请海外高校做好准备</b>
                    <p>Comprehensive Capabilities Promoting</p>
                </div>
                <div class="works-step clearfix">
                    <div>5</div>
                    <b>个人品牌管理</b>
                    <p>Manage Your Personal Brand</p>
                </div>
                <div class="works-step clearfix">
                    <div>6</div>
                    <b>多任务处理能力, 决策能力, 创新能力</b>
                    <p>Multitasking Handling Decision Making</p>
                </div>
            </div>
        </div>
        <!-- waypoint handler functions -->
        <v-waypoint
        @waypoint-in="$store.dispatch('updateSticky')"
        @waypoint-out="$store.dispatch('updateSticky')"
        ></v-waypoint>
    </section>
</template>

<script>
export default {
}
</script>

<style lang="scss">
@import "../../assets/resources/css/partials/variables";

.section-skills {
    background-color: #f4f4f4;
}

.skill-sets {
    padding-left: auto;
    padding-right: auto;
}

.steps-box {
    margin-top: 30px;
    margin-left: 10%;
    width: 40%;

    &:first-child {
        @media only screen and (max-width: $medium-screen) {
            text-align: center;
        }
    }

}

.works-step {
    margin-bottom: 50px;

    &:last-of-type {
        margin-bottom: 20px;
    }

    @media only screen and (max-width: $medium-screen) {
        margin-bottom: 20px;
    }

    div {
        color: $theme-color;
        font-size: 150%;
        height: 54px;
        width: 56px;
        border: 2px solid $theme-color;
        border-radius: 50%;
        display: inline-block;
        text-align: center;
        margin-right: 25px;
        float: left;
        padding: 5px;

        @media only screen and (max-width: $medium-screen) {
            height: 40px;
            width: 40px;
            margin-right: 15px;
            padding: 4px;
            font-size: 120%;
        }
    }

    p {
        @media only screen and (max-width: $small-screen) {
            font-size: 0.8rem;
        }
    }

    b {
        @media only screen and (max-width: $small-screen) {
            font-size: 0.9rem;
        }
    }
}

</style>



// WEBPACK FOOTER //
// Skills.vue?484231f1